import PropTypes from "prop-types";
import React from "react";

import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";

const CheckboxFormField = ({ label, className, ...rest }) => {
  return (
    <FormGroup className={className}>
      <FormControlLabel control={<Checkbox inputProps={{ "aria-label": "controlled" }} {...rest} />} label={label} />
    </FormGroup>
  );
};

CheckboxFormField.propTypes = {
  label: PropTypes.node,
  className: PropTypes.string,
};

export default CheckboxFormField;
